import React, { useState, useEffect } from 'react';
import { Form, Select, Input, InputNumber, Button, message, Switch } from 'antd';

// import axios from 'axios'
import axios from '../axios/axios'
import servicePath from '../config/apiUrl'

const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 15 },
};

const validateMessages = {
    required: '${label} 必须填写!',
    types: {
        email: '${label} is not validate email!',
        number: '${label} is not a validate number!',
    },
    number: {
        range: '${label} must be between ${min} and ${max}',
    },
};


function EditCamera(props) {
    const [cmData, setcmData] = useState([]);
    const [cId, setcId] = useState();
    const [hideSW, setHideSW] = useState();
    const [posturl, setPosturl] = useState();
    const [categoriesList, setCategoriesList] = useState([]);
    const [adList, setAdList] = useState([]);
    // const [surfSpotGeoList, setSurfSpotGeoList] = useState([]);
    const [fields, setFields] = useState([
        {
            name: ['user', 'cId'],
            value: '123454',
        },
    ]);
    let cid = props.match.params.id
    var postFile = null;

    //得到文章列表
    const getList = () => {
        const hide = message.loading('...', 0);


        axios({
            method: 'get',
            url: servicePath.getCameraInfo + "/" + cid,
            // withCredentials: true,

            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                setTimeout(hide, 100);

                if (res.data.code == 1) {
                    setPosturl(res.data.data.post_url)
                    setHideSW(res.data.data.hide == 1 ? 0 : 1)
                    console.log("cm info:", res.data)
                    // res.data.data
                    setFields([
                        {
                            name: ['user', 'cId'],
                            value: res.data.data.cId,
                        },
                        {
                            name: ['user', 'name'],
                            value: res.data.data.name,
                        },
                        {
                            name: ['user', 'city'],
                            value: res.data.data.city,
                        },
                        {
                            name: ['user', 'data_url'],
                            value: res.data.data.data_url,
                        }, {
                            name: ['user', 'post_url'],
                            value: res.data.data.post_url,
                        }, {
                            name: ['user', 'sponsor'],
                            value: res.data.data.sponsor,
                        }, {
                            name: ['user', 'gl_url'],
                            value: res.data.data.gl_url,
                        }, {
                            name: ['user', 'latitude'],
                            value: res.data.data.latitude,
                        }, {
                            name: ['user', 'longitude'],
                            value: res.data.data.longitude,
                        }, {
                            name: ['user', 'sort'],
                            value: res.data.data.sort,
                        }, {
                            name: ['user', 'live_src'],
                            value: res.data.data.live_src,
                        }, {
                            name: ['user', 'show_play_icon'],
                            value: res.data.data.show_play_icon === 1 ? true : false,
                        }, {
                            name: ['user', 'show_rec_icon'],
                            value: res.data.data.show_rec_icon === 1 ? true : false,
                        }, {
                            name: ['user', 'chain_weather_url'],
                            value: res.data.data.chain_weather_url,
                        }, {
                            name: ['user', 'adId_list'],
                            value: res.data.data.adId_list ? JSON.parse(res.data.data.adId_list) : [],
                        }, {
                            name: ['user', 'city_category'],
                            value: res.data.data.city_category,
                        }, {
                            name: ['user', 'hide'],
                            value: true
                        }// , {
                        //     name: ['user', 'surf_spot_geo_id'],
                        //     value: res.data.data.ssg_id ? parseInt(res.data.data.ssg_id) : undefined,
                        // }
                    ])
                    //   (res.data.data.hide===1?true:false),
                    // setcId(res.data.data.cId)
                } else {
                    console.log("好像没有这个摄像头的数据:", res.data)
                }


            }
        )

    }
    useEffect(() => {
        getList()
        getCategoriesList()
        getAdList()
        // getSurfSpotGeoList()
    }, [])
    // 获取城市分类
    const getCategoriesList = () => {
        axios({
            method: 'get',
            url: servicePath.getCategoriesList,
            withCredentials: true,
            header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    setCategoriesList(res.data.list)

                }
            }
        ).catch((res) => {
            console.log("err", res)
        })
    }

    // 获取城市分类
    const getAdList = () => {
        axios({
            method: 'get',
            url: servicePath.getAdlList,
            withCredentials: true,
            header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    setAdList(res.data.list)

                }
            }
        ).catch((res) => {
            console.log("err", res)
        })
    }
    
    // 获取浪点地理列表
    // const getSurfSpotGeoList = () => {
    //     axios({
    //         method: 'get',
    //         url: servicePath.getSurfSpotGeoList,
    //         withCredentials: true,
    //         header: { 'Access-Control-Allow-Origin': '*' }
    //     }).then(
    //         res => {
    //             if (res.data.code == 1) {
    //                 setSurfSpotGeoList(res.data.list)
    //             }
    //         }
    //     ).catch((res) => {
    //         console.log("err", res)
    //     })
    // }

    const clSwitch = (checked, event) => {
        console.log("cl checked", checked)
        console.log("cl event", event)
        console.log("hideSW:", hideSW)
        // setHideSW
        setHideSW(!hideSW)
    }

    const onFinish = values => {
        console.log("hideSW:", hideSW);
        // console.log("setFields:",setFields.user)
        let fromData = values.user;
        if (!fromData.name) {
            message.error('摄像头name')
            return false
        } else if (!fromData.city) {
            message.error('城市称不能为空')
            return false
        } else if (!fromData.data_url) {
            message.error('爬取数据连接不能为空')
            return false
        } else if (!fromData.sponsor) {
            message.error('赞助商不能为空')
            return false
        } else if (!fromData.latitude) {
            message.error('latitude不能为空')
            return false
        } else if (!fromData.longitude) {
            message.error('longitude不能为空')
            return false
        }
        // else if(!fromData.live_src){
        //     message.error('摄像头直播源地址不能为空')
        //     return false
        // }
        // message.success('检验通过');
        // 经纬度数据fromData.latitude+fromData.longitude
        let jwd = {
            latitude: fromData.latitude,
            longitude: fromData.longitude,
            adId_list: fromData.adId_list ? JSON.stringify(fromData.adId_list) : null,//广告列表
            city_category: fromData.city_category,//城市分类
            // ssg_id: fromData.surf_spot_geo_id,//浪点地理ID
            sort: fromData.sort || 0,
            chain_weather_url: fromData.chain_weather_url//中国天气网天气连接
        }
        // 创建formdata  // postFile
        console.log("postFile:", postFile)
        var formData = new FormData();
        formData.append("post_url", postFile);
        formData.append("cId", fromData.cId);
        formData.append("name", fromData.name);
        formData.append("city", fromData.city);
        formData.append("live_src", fromData.live_src || '');
        formData.append("show_play_icon", fromData.show_play_icon ? 1 : 0);
        formData.append("show_rec_icon", fromData.show_rec_icon ? 1 : 0);
        formData.append("data_url", fromData.data_url);
        formData.append("gl_url", fromData.gl_url);
        formData.append("sponsor", fromData.sponsor);
        formData.append("jwd", JSON.stringify(jwd));

        formData.append("hide", hideSW ? 0 : 1);
        axios({
            method: 'POST',
            url: servicePath.editCameraInfo,
            data: formData,
            // withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                console.log(res)


                if (res.data.code == 1) {

                    setTimeout(() => {
                        props.history.push('/')
                    }, 2000)
                    message.success('修改摄像头信息成功！');
                } else {
                    message.error("修改摄像头信息失败2！");
                }


            }
        ).catch((res) => {
            console.log("err", res)
            message.error("修改摄像头信息失败2！");
        })
    };

    // 手动刷新当前摄像头的天气预报（调用后端 /admin/crawlSingleCamera）
    const refreshForecast = () => {
        const hide = message.loading('正在刷新预报数据...', 0);
        axios({
            method: 'POST',
            url: servicePath.crawlSingleCamera,
            data: { cId: cid },
        }).then(
            res => {
                setTimeout(hide, 100);
                if (res.data.code == 1) {
                    message.success('预报数据刷新成功！');
                } else {
                    message.error(res.data.msg || '刷新失败');
                }
            }
        ).catch((res) => {
            setTimeout(hide, 100);
            console.log("refreshForecast err", res)
            message.error("刷新预报失败！");
        })
    };

    const getUrl = values => {
        console.log("getUrl", values);

        var file = document.getElementById("upload")
        var preview = document.getElementById("preview");


        // 创建文件读取对象
        var reader = new FileReader();
        // 用户选择的文件列表
        postFile = file.files[0];
        console.log("files[0]", file.files[0]);
        // 读取文件
        reader.readAsDataURL(file.files[0]);
        // 监听onload事件
        reader.onload = function () {
            console.log(reader.result);
            // 将读取的结果显示在页面中
            preview.src = reader.result;
        }

    };
    // action="upload.php"
    return (
        <Form {...layout} name="nest-messages" fields={fields} onFinish={onFinish} method="post" enctype="multipart/form-data" validateMessages={validateMessages}>
            <Form.Item name={['user', 'cId']} label="摄像头Id" rules={[{ required: true }]}>
                <Input defaultValue={cId} maxLength='10' disabled={1} />
            </Form.Item>
            <Form.Item name={['user', 'name']} label="name" rules={[{ required: true }]}>
                <Input />
            </Form.Item>

            <Form.Item name={['user', 'city']} label="城市" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'data_url']} label="爬取数据连接" rules={[{ required: true }]}>
                <Input />
            </Form.Item>

            <Form.Item name={['user', 'post_url']} label="海报图" >
                <input onChange={() => { getUrl() }} type="file" placeholder="选择上传海报图" accept="image/*" id="upload" ></input>
                <img style={{ width: '200px', height: 'auto', padding: '20px 0' }} id="preview" src={servicePath.serverUrl + posturl} />
                <div style={{ padding: '10px 0' }}>建议图片尺寸：(348px * 190px)</div>
            </Form.Item>
            <Form.Item name={['user', 'sponsor']} label="赞助商" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'gl_url']} label="浪点攻略网页" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'latitude']} label="latitude" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'longitude']} label="longitude" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'sort']} label="排序" >
                <Input placeholder='数值越大排越前' type='number' />
            </Form.Item>
            <Form.Item name={['user', 'live_src']} label="摄像头直播源地址" >
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'show_play_icon']} label="显示播放图标" valuePropName="checked">
                <Switch defaultChecked={true} />
            </Form.Item>
            <Form.Item name={['user', 'show_rec_icon']} label="显示录制图标" valuePropName="checked">
                <Switch defaultChecked={false} />
            </Form.Item>
            <Form.Item name={['user', 'chain_weather_url']} label="这个天气网接口地址" >
                <Input />
            </Form.Item>
            <Form.Item name={['user', 'city_category']} label="城市分类" >
                <Select placeholder="请选择城市分类">
                    {
                        categoriesList.map((item) => {
                            return <Select.Option value={item.ctId}>{item.category_name}</Select.Option>
                        })
                    }
                </Select>
            </Form.Item>
            {/* <Form.Item name={['user', 'surf_spot_geo_id']} label="浪点所属地理信息">
                <Select placeholder="请选择浪点所属地理信息">
                    {
                        surfSpotGeoList.map((item) => {
                            return <Select.Option key={parseInt(item.id)} value={parseInt(item.id)}>{item.district} {item.province} {item.country}</Select.Option>
                        })
                    }
                </Select>
            </Form.Item> */}
            <Form.Item name={['user', 'adId_list']} label="广告列表id" >
                <Select mode="multiple" placeholder="请选择广告">
                    {
                        adList.map((item) => {
                            return <Select.Option value={item.adId}>（ID:{item.adId} - 类型：{item.type_id == 'big' ? '大' : '小'}）{item.title}</Select.Option>
                        })
                    }
                </Select>
            </Form.Item>
            <Form.Item label="是否显示"  >

                <Switch checked={hideSW} onClick={() => { clSwitch() }} />
            </Form.Item>
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                <Button type="primary" htmlType="submit">
                    修改摄像头数据
                </Button>
                <Button style={{ marginLeft: 12 }} onClick={() => refreshForecast()}>
                    手动刷新预报
                </Button>
            </Form.Item>
        </Form>
    )
}
export default EditCamera